import { render, staticRenderFns } from "./BooleanColumn.vue?vue&type=template&id=f390a152&scoped=true"
import script from "./BooleanColumn.vue?vue&type=script&lang=js"
export * from "./BooleanColumn.vue?vue&type=script&lang=js"
import style0 from "./BooleanColumn.vue?vue&type=style&index=0&id=f390a152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f390a152",
  null
  
)

export default component.exports